import { render, staticRenderFns } from "./projectRegister.vue?vue&type=template&id=9101148c&"
import script from "./projectRegister.vue?vue&type=script&lang=js&"
export * from "./projectRegister.vue?vue&type=script&lang=js&"
import style0 from "./projectRegister.vue?vue&type=style&index=0&id=9101148c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports